[
  {
    "id": "SR-E8-MILLENNIUM-V01",
    "module": "SpellingRegel",
    "difficulty": 305,
    "difficultyTier": 17,
    "levelCode": "E8",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-MILLENNIUM",
    "conceptId": "latin_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["millennium", "milennium", "millenium", "milenium"],
    "correctAnswer": 0,
    "explanation": "'Millennium' heeft een dubbele 'l' én een dubbele 'n'. Onthoud: mil-len-ni-um. Het komt van het Latijnse 'mille' (duizend) + 'annum' (jaar).",
    "distractorExplanations": {
      "1": "Hier ontbreekt een 'l'. Het woord heeft dubbel-l: mil-len-nium.",
      "2": "Hier ontbreekt een 'n'. Het woord heeft dubbel-n: millen-ni-um.",
      "3": "Hier ontbreken zowel een 'l' als een 'n'. Beide zijn dubbel."
    }
  },
  {
    "id": "SR-E8-AGRESSIE-V01",
    "module": "SpellingRegel",
    "difficulty": 305,
    "difficultyTier": 17,
    "levelCode": "E8",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-AGRESSIE",
    "conceptId": "tricky_single_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["agressie", "agresie", "aggressie", "aggresie"],
    "correctAnswer": 0,
    "explanation": "'Agressie' heeft één 'g' en een dubbele 's'. Onthoud: a-gres-sie. De dubbele letter is de 's', niet de 'g'. Veel mensen maken hier een fout!",
    "distractorExplanations": {
      "1": "Hier ontbreekt een 's'. Het woord heeft dubbel-s: agres-sie.",
      "2": "Hier staat een dubbele 'g', maar het woord heeft maar één 'g'.",
      "3": "Hier staat een dubbele 'g' maar ontbreekt een 's'. Het is één 'g', dubbele 's'."
    }
  },
  {
    "id": "SR-E8-COMMISSARIS-V01",
    "module": "SpellingRegel",
    "difficulty": 305,
    "difficultyTier": 17,
    "levelCode": "E8",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-COMMISSARIS",
    "conceptId": "latin_double_consonants",
    "variantIndex": 1,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["commissaris", "comissaris", "commisaris", "comisaris"],
    "correctAnswer": 0,
    "explanation": "'Commissaris' heeft een dubbele 'm' én een dubbele 's'. Onthoud: com-mis-sa-ris. Twee keer een dubbele medeklinker.",
    "distractorExplanations": {
      "1": "Hier ontbreekt een 'm'. Het woord heeft dubbel-m: com-mis-saris.",
      "2": "Hier ontbreekt een 's'. Het woord heeft dubbel-s: commis-sa-ris.",
      "3": "Hier ontbreken zowel een 'm' als een 's'. Beide zijn dubbel."
    }
  },
  {
    "id": "SR-E8-ONMIDDELLIJK-V01",
    "module": "SpellingRegel",
    "difficulty": 305,
    "difficultyTier": 17,
    "levelCode": "E8",
    "group": 8,
    "skill": "weetwoorden",
    "subSkill": "weetwoorden_moeilijk",
    "familyId": "SR-WEETWOORD-ONMIDDELLIJK",
    "conceptId": "tricky_double_consonants",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Welk woord is goed geschreven?",
    "options": ["onmiddellijk", "onmidelijk", "onmiddelijk", "onmidellijk"],
    "correctAnswer": 0,
    "explanation": "'Onmiddellijk' heeft dubbele 'd' én dubbele 'l'. Onthoud: on-middel-lijk. Het woord 'middel' zit erin, plus het achtervoegsel '-lijk'.",
    "distractorExplanations": {
      "1": "Hier ontbreken een 'd' en een 'l'. Het woord heeft dubbel-d en dubbel-l.",
      "2": "Hier ontbreekt een 'l'. Het achtervoegsel is '-lijk', niet '-ijk'.",
      "3": "Hier ontbreekt een 'd'. Het is 'middel', niet 'midel'."
    }
  },
  {
    "id": "SR-E8-GEELEKTROCUTEERD-V01",
    "module": "SpellingRegel",
    "difficulty": 305,
    "difficultyTier": 17,
    "levelCode": "E8",
    "group": 8,
    "skill": "schrijfwijze",
    "subSkill": "trema",
    "familyId": "SR-TREMA-VOORVOEGSEL",
    "conceptId": "trema_prefix_vowel_collision",
    "variantIndex": 3,
    "questionType": "multiple_choice",
    "question": "Kies het juiste woord: ...",
    "options": ["geëlektrocuteerd", "geelektrocuteerd", "geëlectrocuteerd", "geëlektrocuteert"],
    "correctAnswer": 0,
    "explanation": "Na het voorvoegsel 'ge-' komt een 'e'. Trema nodig: geëlektrocuteerd. Met een 'k' (niet 'c') en het is een voltooid deelwoord (eindigt op '-d').",
    "distractorExplanations": {
      "1": "Trema vergeten. Zonder trema zou je 'gee-lektrocuteerd' lezen.",
      "2": "In het Nederlands schrijven we 'elektro' met een 'k', niet met een 'c'.",
      "3": "Het is een voltooid deelwoord, dus het eindigt op '-d', niet op '-t'."
    }
  }
]